/**
 * Regular expression for ISO 8601 duration strings. It will also accept negative values to take delays like
 * infringements into account. It will also accept floating point values for seconds to enable milliseconds.
 *
 * This regex is a modified version of the one found at the following link:
 * @link https://stackoverflow.com/a/32045167
 * This implementation will therefore accept negative values and allow floating point values for seconds only.
 *
 * @example ISO_8601_DURATION_REGEX.test('P-1Y2M-3DT4H-5.5M-6S')
 * @type {RegExp}
 */
export const ISO_8601_DURATION_REGEX =
    /^-?P(?!$)(-?\d+(?:\d+)?Y)?(-?\d+(?:\d+)?M)?(-?\d+(?:\d+)?W)?(-?\d+(?:\d+)?D)?(T(?=-?\d)(-?\d+(?:\d+)?H)?(-?\d+(?:\d+)?M)?(-?\d+(?:\.\d+)?S)?)?$/
